import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  HelvetiaVariant
} from '../../../../models/helvetia.model';
import { DmrResponse } from '../../../../models/dmr.model';
import { LibUtilityService } from '../../../../utils';

@Component({
    selector: 'lib-ksf-warrings-display',
    templateUrl: './ksf-warrings-display.component.html',
    styleUrls: ['./ksf-warrings-display.component.scss'],
    standalone: false
})
export class KsfWarringsDisplayComponent {
  // Event emitted to the parent component
  @Output() setSelectedHelvetiaVariantEvent =
    new EventEmitter<HelvetiaVariant>();

  @Output() pickHelvetiaEvent = new EventEmitter<boolean>();
  @Output() pickSjfEvent = new EventEmitter<boolean>();

  // Input properties to receive data from the parent component
  @Input() ksfPriceResult: any;

  @Input() errorIngetInsurancePrices: boolean = false;
  @Input() allHaveTogglePricetag: boolean = false;
  @Input() showYearlyPrice: boolean = false;
  @Input() vehicleFromDmr: DmrResponse = {} as DmrResponse;

  // Forsia input need to show altenative Forsia price if KFS cant/ wont show a price
  @Input() errorInSJFPrice: boolean = false;
  @Input() forsiaExcessPrices: any;
  @Input() forsiaPrices: any;
  @Input() selectedforsiaExcessIndex: number = 0;
  @Input() forsiaTotalPrice: number = 0;
  @Input() forsiaPriceLoading: boolean = false;

  recalculateForsiaPrice() {}

  // Helvetia input need to show altenative Helvetia price if KFS cant/ wont show a price
  @Input() errorInHelvetiaPrice: boolean = false;
  @Input() helvetiaMonthlyPrice: number = 0;
  @Input() helvetiaYearlyPrice: number = 0;
  @Input() helvetiaVariants: HelvetiaVariant[] = [];
  @Input() selectedHelvetiaVariant: HelvetiaVariant = {} as HelvetiaVariant;

  constructor(
    private libUtilityService: LibUtilityService
  ) {}

  /**
   * Emits an event to pick the Helvetia price
   */
  pickHelvetia(goToNextStep: boolean) {
    this.pickHelvetiaEvent.emit(goToNextStep);
  }

  /**
   * Emits an event to pick the SJf price
   */
  pickSjf(goToNextStep: boolean) {
    this.pickSjfEvent.emit(goToNextStep);
  }

  /**
   * Set the yearly and monthly prices for the selected Helvetia variant.
   * Retrieves the prices from the utility service based on the coverages of the selected Helvetia variant.
   * @returns void
   */
  setYearlyAndMonthlyPrice() {
    // TODO: NEED TO ADD ADDON PRICES?

    this.helvetiaMonthlyPrice = this.libUtilityService.getHelvetiaPrice(
      this.selectedHelvetiaVariant.coverages,
      'monthly'
    );

    this.helvetiaYearlyPrice = this.libUtilityService.getHelvetiaPrice(
      this.selectedHelvetiaVariant.coverages,
      'yearly'
    );
  }

  /**
   * Set the selected Helvetia variant and emit an event with the updated variant.
   * @param helvetiaVariant - The Helvetia variant to be set as the selected variant.
   * @returns void
   */
  setSelectedHelvetiaVariant(helvetiaVariant: HelvetiaVariant) {
    this.selectedHelvetiaVariant = helvetiaVariant;
    this.setSelectedHelvetiaVariantEvent.emit(this.selectedHelvetiaVariant);
  }
}
